import { createAsyncThunk } from '@reduxjs/toolkit';

import { getMonitoringSystemListService } from 'services/monitoring_system.service';

export const getMonitoringSystemList = createAsyncThunk(
  'monitoringSystem/list',
  async (_, thunkApi) => {
    try {
      const response = await getMonitoringSystemListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
